/* Position the button absolutely over the right side of the input */
.clear-button {
  position: absolute;
  /* top: 10%; */
  left: 0px;
  /* right: 8px; */
  /* top: 50%; */
  transform: translateX(-125%);
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 50%;

  height: 1em;  
  width: 1em;
  overflow: visible;
  padding: 0;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  
  /* Hide the button by default */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease, background-color 0.2s ease;
}

/* Show the clear button whenever the user hovers over the entire container */
.clear-button-parent:hover .clear-button {
  opacity: 1;
  visibility: visible;
}

/* Optional: change color when hovering directly over the X button */
.clear-button:hover {
  color: #ffffff;
  background-color: rgb(102, 101, 101);
}

.clear-button-container {
    position: relative;
    width: 0;
    display: inline-flex;
    align-items: center;
}